export default "__VITE_ASSET__Drd5X1Ej__"